import React from 'react';
import {View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {observer} from 'mobx-react-lite';

import AddToWallet from '../../components/rewards/AddToWallet';
import InStoreCode from '../../components/rewards/InStoreCode';
import MemberCard from '../../components/rewards/MemberCard';
import Button from '../../components/themed/Button';
import Text from '../../components/themed/Text';
import ContentView from '../../components/ui-controls/layout/ContentView';
import config from '../../config';
import logoImg from '../../images/brand/header-logo.png';
import AccessYourCard from '../rewards/AccessYourCard';

type RequireAll<TOptional, TRequired> =
  | (TOptional & TRequired)
  | (Partial<Record<keyof TOptional, never>> & TRequired);

type SuccessLoyaltyProps = RequireAll<
  {
    inStoreCode: string;
    fullName: string;
    cardNumber: string;
    walletUrl: string;
  },
  {
    goToHome: () => void;
    title: string;
    text: string | React.ReactNode;
    pending?: boolean;
    ctaTitle?: string;
    memberSince?: string;
    isStaff?: boolean;
    isLmgStaff?: boolean;
  }
>;

/**
 * Success screen with loyalty card
 */
const SuccessLoyalty = observer((props: SuccessLoyaltyProps) => {
  const {
    title,
    text,
    inStoreCode,
    walletUrl,
    cardNumber,
    fullName,
    pending,
    goToHome,
    ctaTitle,
    memberSince,
    isStaff,
    isLmgStaff,
  } = props;

  return (
    <KeyboardAwareScrollView style={{backgroundColor: 'white'}} keyboardShouldPersistTaps="always">
      <ContentView>
        <Text variant="heading1">{title}</Text>

        {typeof text === 'string' ? <Text variant="body2">{text}</Text> : text}

        <View style={{gap: 8, marginTop: 24}}>
          <MemberCard
            pending={pending}
            logoImg={logoImg}
            cardNumber={cardNumber || ''}
            name={fullName || ''}
            memberSince={memberSince}
            isStaff={isStaff}
            isLmgStaff={isLmgStaff}
          />
          {/* DIS-1556: Zen only issues the consumer card template, so the wallet
              pass never generates for staff members. Hide the dead button. */}
          {!isStaff && !isLmgStaff && <AddToWallet pending={pending} walletUrl={walletUrl || ''} />}
        </View>

        {!!inStoreCode && (
          <>
            <Text style={{fontWeight: 600, marginTop: 50}} variant="heading2">
              Your temporary rewards code
            </Text>
            <Text variant="body2" style={{marginTop: 8}}>
              Want to keep ahold of your phone? Give this code at checkout instead.
            </Text>

            <InStoreCode inStoreCode={inStoreCode} />
            <View style={{height: 50}} />
            <AccessYourCard />
          </>
        )}

        <View style={{gap: 8, marginTop: 20}}>
          <Button
            secondary
            title={ctaTitle || `GO TO ${config.APP_NAME.toUpperCase()} HOME`}
            onPress={goToHome}
          />
        </View>
      </ContentView>
    </KeyboardAwareScrollView>
  );
});

export default SuccessLoyalty;
